export default __webpack_public_path__ + "static/media/Pattern1.3251ae15.png";